import React, { useEffect, useState } from 'react';
import { StudyGuideDiagnosticChart } from './study-guide-diagnostic-chart';
import { useClient } from 'jsonapi-react';
import { EmptyState } from '@/components/custom/empty-state';
import { DialogContent, DialogTitle } from '@/components/ui/dialog';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import { cn } from '@/lib/utils';

export function StudyGuideDiagnosticModal({ question_book_user_id = 0, title = 'Rendimento em prova diagnóstica' }) {
  const playful = usePlayfulStudent();
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const client = useClient();

  const getChartData = async () => {
    try {
      const response = await client.fetch(`study_plan_reports/question_books_chart?question_book_user_id=${question_book_user_id}`);
      return response.data;
    } catch (err) {
      setError('Erro ao carregar os dados');
      console.error(err);
    }
  };

  useEffect(() => {
    if (question_book_user_id) {
      setLoading(true);
      getChartData().then(data => {
        if (data && data.question_books_chart) {
          const chartData = data.question_books_chart.map(chart => ({
            value: parseFloat(chart.score).toFixed(2),
            label: chart.name
          }));

          setChartData(chartData);
        }
        setLoading(false);
      });
    }
  }, [question_book_user_id]);

  if (!question_book_user_id) return null;

  return (
    <DialogContent size="lg">
      <DialogTitle
        border
        className={cn(playful && 'font-extrabold')}
        style={playful ? { color: 'var(--color-secondary)' } : undefined}
      >
        {title}
      </DialogTitle>

      {loading ? (
        <p className="mb-4">Carregando...</p>
      ) : error ? (
        <p className="mb-4">{error}</p>
      ) : chartData.length > 0 ? (
        <StudyGuideDiagnosticChart chartData={chartData} />
      ) : (
        <EmptyState
          type="data"
          title="Você ainda não respondeu uma prova diagnóstica"
          text=" "
          variant="plain"
        />
      )}
    </DialogContent>
  );
}
